import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthToken } from './useAuthToken';

export const useStoreContext = () => {
  const [storeContext, setStoreContext] = useState({
    storeId: null,
    storeName: null,
    storeSubdomain: null
  });
  
  const { token } = useAuthToken();

  useEffect(() => {
    const fetchStoreData = async () => {
      if (!token) return;

      try {
        // Get user ID from localStorage (existing pattern)
        const userId = localStorage.getItem('user_id');
        if (!userId) return;

        // Fetch store data from business profile or store settings
        const response = await axios.get(`${process.env.REACT_APP_APIURL}business/profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.data.success && response.data.result) {
          const storeData = response.data.result;
          setStoreContext({
            storeId: userId, // Use user_id as store_id
            storeName: storeData.business_name || storeData.store_name || 'My Store',
            storeSubdomain: storeData.store_subdomain || storeData.subdomain
          });
        }
      } catch (error) {
        console.error('Failed to fetch store context:', error);
        // Fallback to localStorage data if available
        const userId = localStorage.getItem('user_id');
        const storeUrl = localStorage.getItem('store_url');
        
        if (userId) {
          setStoreContext({
            storeId: userId,
            storeName: 'My Store', // Default name
            storeSubdomain: storeUrl ? storeUrl.replace('https://', '').replace('.mytamilkart.com', '') : null
          });
        }
      }
    };

    fetchStoreData();
  }, [token]);

  return storeContext;
};